import { AloftPrice, PROPERTY_GRID_SUBJECT_PROPERTY, orUndefined } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectImprovementEntityIds } from '../propertyDataSelectors/improvementsSelectors.ts';
import { selectManualAdjustmentsEntities } from '../propertyDataSelectors/manualAdjustmentsSelectors.ts';
import { selectReconciliation } from '../selectReconciliation.ts';

export const selectTotalCostToCureAdjs = createSelector(
  [selectReconciliation, selectImprovementEntityIds, selectManualAdjustmentsEntities],
  (reconciliation, improvementEntityIds, manualAdjustmentsEntities) =>
    improvementEntityIds.reduce((acc: Record<string, AloftPrice>, propertyId) => {
      const adj = orUndefined(AloftPrice.schema.parse)(
        propertyId === PROPERTY_GRID_SUBJECT_PROPERTY
          ? reconciliation.totalCostToCure
          : manualAdjustmentsEntities[propertyId]?.totalCostToCure,
      );

      if (adj) acc[propertyId] = adj;
      return acc;
    }, {}),
);
